import './App.css';
import Timeline from './pages/Timeline/Timeline'

function App() {
  return (
      <div className="app">
      <div className="container">
      <div className="mystic goright"></div>
      <div className="mystic goleft"></div>
      

      <Timeline />
      </div>
    </div>
  
  );
}

export default App;
